import {isMobile} from "mobile-device-detect";

export function KeyboardMobileHidden() {
  if (!isMobile) return;
  setTimeout(() => {
    const datePickers = document.querySelectorAll('.el-date-editor .el-input__inner');
    if (datePickers) {
      datePickers.forEach(picker => {
        if (!picker.getAttribute('inputmode')) {
          picker.setAttribute('inputmode', 'none');
        }
      });
    }
  }, 0);
}
